export default function removeEmpty(obj: object): object {
    return Object.fromEntries(
        Object.entries(obj)
            .filter(([_, v]) => v !== null && v !== undefined)
            .map(([k, v]) => [k, v === Object(v) ? removeEmpty(v) : v])
    );
}

export function getEmptyProperties(obj: object): string[] {
    return Object.entries(obj).flatMap(([k, v]) => {
        if (v === null || v === undefined) {
            return [k];
        }
        if (typeof v === 'object') {
            return getEmptyProperties(v).map(a => `${k}.${a}`);
        }
        return [];
    })
}
